export default __webpack_public_path__ + "static/media/146.8de1dfec.jpg";